<template>
  <div class="solution-us">
    <h3 class="title">我们公司产品特性</h3>
    <div class="bar">
      <div class="circular"></div>
    </div>
    <p class="subheading">结合项目的实际应用场景，业务种类繁多，业务服务相对独立。为了实现系统服务平滑上线、动态扩容，以及后台服务结构清晰、运行稳定和科学运维</p>
    <div class="solution-main">
      <div class="solution">
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="icon-img" name="cog" />
            </div>
            <div class="display">
              <h3>采用B/S多层体系架构</h3>
              <p class="detailed">
                应用系统均采用B/S架构，多层体系结构对各层重点进行松耦合分治管理，
                分为表示层、业务逻辑层及数据访问层三个层次。
              </p>
            </div>
          </div>
        </div>
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="icon-img" name="database" />
            </div>
            <div class="display">
              <h3>全面支持Docker容器部署</h3>
              <p class="detailed">
                项目支持使用容器部署，将应用前端、后端以及数据库进行隔离，应用之间松耦合连接，将复杂业务清晰化、运维管理标准化。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="solution">
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon bg">
              <v-icon class="icon-img" name="sitemap" />
            </div>
            <div class="display">
              <h3>采用前后端分离技术</h3>
              <p class="detailed">
                项目使用前后端分离技术，结合容器技术，一是应用模块化；
                二是技术模块化。前后端分离技术，可划清前后端开发人员的职责分工，提升开发效率。
                同时，也有利于系统分布式部署。
              </p>
            </div>
          </div>
        </div>
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon bg">
              <v-icon class="icon-img" name="share-alt" />
            </div>
            <div class="display">
              <h3>统一安全网关</h3>
              <p class="detailed">
                为了应对系统服务大量的用户访问，同时，满足容器技术和前后端分离技术的高效应用，使用Nginx + Lua技术，
                在系统内外提供服务接口调用、安全认证、路由、策略等服务网关能力。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="solution">
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon bg2">
              <v-icon class="icon-img" name="recycle" />
            </div>
            <div class="display">
              <h3>支持WEB 3d</h3>
              <p class="detailed">
                根据业务需要，可定制化3D模板，在WEB端展示，并能与物联网数据进行对接，在3D图形上即可进行智能设备的监控操作。
              </p>
            </div>
          </div>
        </div>
        <div class="solution-content">
          <div class="grid-content clearance">
            <div class="icon bg2">
              <v-icon class="icon-img" name="desktop" />
            </div>
            <div class="display">
              <h3>IOT数据项目隔离</h3>
              <p class="detailed">
                IoT云端管理系统，按项目进行数据隔离，每个项目可分配给业务系统接口访问密钥对。采用安全加密技术，项目间数据不混淆。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "solution"
};
</script>

<style lang="scss" scoped>
.solution-us {
  padding-top: 70px;
  padding-bottom: 70px;
  background: #f9f6f6;

  @media (max-width: 768px) {
    .subheading {
      text-align: left;
      text-indent: 25px;
    }
  }
}

.title {
  font-size: 22px;
  margin: 0px;
}

.bar {
  height: 4px;
  width: 90px;
  background: #cdf1d8;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular {
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #44ce6f;
    animation: mymove 4s infinite;
    -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/
   
    @keyframes mymove {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
    
    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  font-size: 14px;
  max-width: 520px;
  margin: 0 auto;
  margin-bottom: 50px;
  color: #6084a4;
  line-height: 1.9;
  padding: 0 15px;
}

.solution-main {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  
  @media (max-width: 605px) {
    width: auto;
    .solution {
      display: block;
    }
  }

  // @media (min-width: 576px) {
  //   max-width: 540px;
  // }

  @media (max-width: 768px) {
    padding: 0;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 992px) {
    max-width: 680px;

    .grid-content {
      padding-left: 20px;

      .icon {
        position: relative;
        left: 0;
        top: 0;
        margin-bottom: 25px;
      }

      .display{
        margin-left: 0px;
      }
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}

.solution {
  display: flex;
  &:last-child {
    margin-bottom: 0;
  }
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.grid-content {
  position: relative;
  border-radius: 5px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  background: #ffffff;
  text-align: left;
  margin-bottom: 30px;
  padding-left: 95px;
  padding-top: 30px;
  padding-right: 20px;
  padding-bottom: 30px;

  h3 {
    transition: 0.5s;
    margin-top: 0px;
    margin-bottom: 17px;
    line-height: 1.4;
    z-index: 999;
    font-size: 16px;
    font-weight: 600;
    color: #0e314c;
  }

  p {
    margin-bottom: 0px;
    transition: 0.9s;
    font-size: 14px;
    color: #6084a4;
    line-height: 1.9;
    letter-spacing: 1px;
  }

  &:hover {
    box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
    transform: translateY(-10px);

    .icon {
      background: #44ce6f;
      & > .icon-img {
        color: #ffffff;
      }
    }

    .bg {
      background: #c679e3;
      & > .icon-img {
        color: #ffffff;
      }
    }

    .bg2 {
      background: #eb6b3d;
      & > .icon-img {
        color: #ffffff;
      }
    }

    &::before {
      width: 50%;
      opacity: 1;
    }

    &::after {
      width: 50%;
      right: 0;
      opacity: 1;
    }
  }

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0px;
    height: 4px;
    background: #44ce6f;
    transition: 0.5s;
    opacity: 0;
  }

  &::after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    width: 0;
    height: 4px;
    background: #44ce6f;
    transition: 0.5s;
    opacity: 0;
  }
}

.clearance {
  margin-bottom: 0px;
}

.icon {
  position: absolute;
  text-align: center;
  width: 55px;
  height: 55px;
  line-height: 62px;
  background: #cdf1d8;
  border-radius: 50%;
  color: #44ce6f;
  left: 20px;
  top: 30px;
  -webkit-transition: 0.5s;
  transition: 0.5s;

  & > .icon-img {
    width: 20px;
    height: 20px;
  }
}

.bg {
  color: #c679e3;
  background: #edc3fc;
  & > .icon-img {
    width: 20px;
    height: 20px;
  }
}

.bg2 {
  color: #eb6b3d;
  background: rgba(235, 107, 61, 0.3);
  & > .icon-img {
    width: 20px;
    height: 20px;
  }
}

.phone {
  transform: rotateY(180deg);
}

.display {
  margin-left: 20px;
}
</style>